module.exports = __webpack_public_path__ + "img/hr-assembling-machine-2-pipe-E.1d66c98e.png";